let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hPvu7")).then(() => parcelRequire('bFtnz'));